(function () {
  if (window.__akPredictiveSearch) return;
  window.__akPredictiveSearch = true;

  var selector = '.retail-search input, .ak-search input[type="search"], header input[type="search"], header input[placeholder*="Search" i]';
  var instances = [];

  function shopRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return typeof root === 'string' ? root : '/';
  }

  function searchUrl(query) {
    return shopRoot() + 'search?q=' + encodeURIComponent(query) + '&type=product';
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function productImage(product) {
    if (product.featured_image && product.featured_image.url) return product.featured_image.url;
    if (product.image) return product.image;
    return '';
  }

  function productLabel(product) {
    return product.vendor || product.type || 'Atulya Karigari';
  }

  function close(instance) {
    instance.panel.hidden = true;
    instance.input.setAttribute('aria-expanded', 'false');
    instance.input.removeAttribute('aria-activedescendant');
    instance.activeIndex = -1;
  }

  function positionPanel(instance) {
    var rect = instance.container.getBoundingClientRect();
    var gutter = 12;
    var left = Math.max(gutter, rect.left);
    var width = Math.min(rect.width, window.innerWidth - (gutter * 2));
    if (left + width > window.innerWidth - gutter) left = window.innerWidth - gutter - width;
    instance.panel.style.left = left + 'px';
    instance.panel.style.top = Math.min(rect.bottom + 8, window.innerHeight - 120) + 'px';
    instance.panel.style.width = width + 'px';
  }

  function open(instance) {
    positionPanel(instance);
    instance.panel.hidden = false;
    instance.input.setAttribute('aria-expanded', 'true');
  }

  function setActive(instance, index) {
    var options = Array.from(instance.panel.querySelectorAll('[role="option"]'));
    if (!options.length) return;
    instance.activeIndex = (index + options.length) % options.length;
    options.forEach(function (option, optionIndex) {
      var active = optionIndex === instance.activeIndex;
      option.classList.toggle('is-active', active);
      option.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    instance.input.setAttribute('aria-activedescendant', options[instance.activeIndex].id);
    options[instance.activeIndex].scrollIntoView({ block: 'nearest' });
  }

  function renderMessage(instance, message) {
    instance.panel.replaceChildren(element('p', 'ak-predictive-message', message));
    open(instance);
  }

  function renderResults(instance, products, query) {
    instance.panel.replaceChildren();
    instance.activeIndex = -1;

    if (!products.length) {
      renderMessage(instance, 'No products found');
      return;
    }

    instance.panel.appendChild(element('p', 'ak-predictive-heading', 'Products'));
    var list = element('div', 'ak-predictive-list');
    products.forEach(function (product, index) {
      var link = element('a', 'ak-predictive-item');
      link.href = product.url;
      link.id = instance.panel.id + '-option-' + index;
      link.setAttribute('role', 'option');
      link.setAttribute('aria-selected', 'false');

      var imageUrl = productImage(product);
      if (imageUrl) {
        var image = document.createElement('img');
        image.src = imageUrl;
        image.alt = '';
        image.width = 52;
        image.height = 64;
        image.loading = 'lazy';
        link.appendChild(image);
      } else {
        link.appendChild(element('span', 'ak-predictive-image-placeholder'));
      }

      var copy = element('span', 'ak-predictive-copy');
      copy.appendChild(element('span', 'ak-predictive-title', product.title));
      copy.appendChild(element('span', 'ak-predictive-meta', productLabel(product)));
      link.appendChild(copy);
      list.appendChild(link);
    });
    instance.panel.appendChild(list);

    var all = element('a', 'ak-predictive-all', 'View all results for “' + query + '”');
    all.href = searchUrl(query);
    instance.panel.appendChild(all);
    open(instance);
  }

  function request(instance) {
    var query = instance.input.value.trim();
    window.clearTimeout(instance.timer);
    if (query.length < 2) {
      if (instance.controller) instance.controller.abort();
      close(instance);
      return;
    }

    instance.timer = window.setTimeout(function () {
      if (instance.controller) instance.controller.abort();
      instance.controller = new AbortController();
      renderMessage(instance, 'Searching…');

      var endpoint = shopRoot() + 'search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,vendor';

      window.fetch(endpoint, {
        signal: instance.controller.signal,
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Predictive search failed');
        return response.json();
      }).then(function (payload) {
        if (instance.input.value.trim() !== query) return;
        var resources = payload && payload.resources && payload.resources.results;
        renderResults(instance, resources && resources.products ? resources.products : [], query);
      }).catch(function (error) {
        if (error.name !== 'AbortError') renderMessage(instance, 'Search is temporarily unavailable');
      });
    }, 180);
  }

  function submit(instance) {
    var query = instance.input.value.trim();
    if (query) window.location.assign(searchUrl(query));
  }

  function setup(input) {
    if (input.dataset.akPredictiveSearch === 'true') return;
    input.dataset.akPredictiveSearch = 'true';

    var container = input.closest('.retail-search, .ak-search, form, [role="search"]') || input.parentElement;
    if (!container) return;
    var panel = element('div', 'ak-predictive-search');
    panel.id = 'AKPredictiveSearch-' + (instances.length + 1);
    panel.setAttribute('role', 'listbox');
    panel.hidden = true;
    document.body.appendChild(panel);

    input.setAttribute('role', 'combobox');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', panel.id);
    input.setAttribute('aria-expanded', 'false');
    input.name = 'q';

    var instance = { input: input, panel: panel, container: container, activeIndex: -1, timer: 0, controller: null };
    instances.push(instance);

    input.addEventListener('input', function () { request(instance); });
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2) request(instance);
    });
    input.addEventListener('keydown', function (event) {
      var options = panel.querySelectorAll('[role="option"]');
      if (event.key === 'ArrowDown' && options.length) {
        event.preventDefault();
        setActive(instance, instance.activeIndex + 1);
      } else if (event.key === 'ArrowUp' && options.length) {
        event.preventDefault();
        setActive(instance, instance.activeIndex - 1);
      } else if (event.key === 'Escape') {
        close(instance);
      } else if (event.key === 'Enter') {
        if (instance.activeIndex >= 0 && options[instance.activeIndex]) {
          event.preventDefault();
          options[instance.activeIndex].click();
        } else {
          event.preventDefault();
          submit(instance);
        }
      }
    });

    var form = input.closest('form');
    if (form) {
      form.action = shopRoot() + 'search';
      form.method = 'get';
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        submit(instance);
      });
    } else {
      var button = container.querySelector('button');
      if (button) button.addEventListener('click', function (event) {
        event.preventDefault();
        submit(instance);
      });
    }
  }

  function setupAll() {
    instances = instances.filter(function (instance) {
      if (instance.input.isConnected) return true;
      instance.panel.remove();
      return false;
    });
    document.querySelectorAll(selector).forEach(setup);
  }

  document.addEventListener('click', function (event) {
    instances.forEach(function (instance) {
      if (!instance.container.contains(event.target) && !instance.panel.contains(event.target)) close(instance);
    });
  });

  window.addEventListener('resize', function () {
    instances.forEach(function (instance) {
      if (!instance.panel.hidden) positionPanel(instance);
    });
  });
  window.addEventListener('scroll', function () {
    instances.forEach(function (instance) {
      if (!instance.panel.hidden) positionPanel(instance);
    });
  }, true);

  new MutationObserver(setupAll).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', setupAll);
  setupAll();
})();

